// src/hooks/useItemValidator.js
import { useEffect, useState } from 'react';
import { parseTradeInput } from '../utils/validateTradeInput';
import { normalizeItemName } from '../utils/normalizeItemName';
import { fetchWithAuth } from '../utils/api';

export const useItemValidator = () => {
  const [validNamesSet, setValidNamesSet] = useState(new Set());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWithAuth('/item-names')
      .then(data => {
        const lowercased = data
          .filter(item => typeof item === 'string')
          .map(item => item.toLowerCase());
        setValidNamesSet(new Set(lowercased));
      })
      .catch(err => console.error('Failed to fetch item names:', err))
      .finally(() => setLoading(false));
  }, []);

  const validate = (inputStr) => {
    if (!validNamesSet.size) {
      return { parsedItems: [], errors: ['Item list not loaded'] };
    }
    return parseTradeInput(inputStr, validNamesSet);
  };

  const validateItemOnly = (inputStr) => {
    const items = inputStr.split(',');
    const validItems = [];
    const errors = [];
    for (let rawItem of items) {
      rawItem = rawItem.trim();
      const name = normalizeItemName(rawItem);
      if (!validNamesSet.has(name)) {
        errors.push(`Unknown item: '${rawItem}'`);
      }
      else {
        validItems.push(name);
      }
    }
    return { validItems, errors };
  };

  return { validate, validateItemOnly, loading };
};
